import React from 'react';
import ReactPlayer from 'react-player';

import ResponsiveImageMobile from 'components/images/ResponsiveImage';
import AnimatedSingleSquare from 'components/images/AnimatedSingleSquare';
import { brandArray } from 'data/home';
import Fade from 'react-reveal/Fade';
import {
  BlackSlideMobile,
  SlideMobile,
  BigText,
  Row,
  MedText,
  BrandRow,
  BrandItem,
  PlayerWrapper,
} from '../styles';

// import { brandArray } from 'data/home';
import { communityRotatingImages } from 'data/rotatingImages';

const generateBrandRow = () => {
  return brandArray.map((brand, idx) => {
    return (
      <BrandItem key={`brand-row-${idx}-item-${idx}`}>
        <img
          src={brand.logo}
          alt={`${brand.alt} logo`}
          className={`logo ${brand.increaseSize ? 'large-logo' : ''}  ${
            brand.joybirdLogo ? 'joybird-logo' : ''
          }`}
        />
        <ResponsiveImageMobile
          srcPath={brand.background}
          imgAlt={brand.alt}
          imgClass="background"
        />
      </BrandItem>
    );
  });
};

const SectionOneMobile = () => {
  return (
    <React.Fragment>
      <BlackSlideMobile>
        <Fade right>
          <div className="flex-column-center">
            <h1 className="quote">
              "In Downtown Los Angeles, ROW DTLA has continued to take shape, transforming 32 acres
              into an all-encompassing iconic destination. It is a growing collective of globally
              recognized shops, restaurants and innovative offices that are spread over six
              buildings to create their own unique L.A. environment."
            </h1>
            <span className="credit">LA MAGAZINE</span>
          </div>
        </Fade>
      </BlackSlideMobile>
      <SlideMobile paddingBottom="5em">
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_1" />
          <Row>
            <BigText className="black-500">
              The perfect mix of LA's progressive merchants, lauded restaurateurs and curated
              events.
            </BigText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_2" />
        </Fade>
        <Fade>
          <Row paddingBottom="5em">
            <MedText className="grey-400">
              In good company, ROW DTLA is home to XXX+ of LA’s most dynamic and “on the pulse”
              companies and sees XXX visitors a year.
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <BrandRow>{generateBrandRow()}</BrandRow>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_3" />
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <PlayerWrapper>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://vimeo.com/357861717"
              playing
              light="/video/player/rowdtla_video_preview_general.jpg"
            />
          </PlayerWrapper>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_4" />
        </Fade>
        <Fade>
          <Row>
            <BigText className="black-500">
              Effortlessly fulfill your day-to-day essentials in this walkable locale
            </BigText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile>
        <Fade>
          <ResponsiveImageMobile srcPath="/images/pages/home/section_2/ROWDTLA_retail-brochure_section2_5" />
        </Fade>
        <Fade>
          <Row>
            <MedText className="black-500">
              Bespoke boutiques, Michelin-starred
              <br />
              eateries, and curated events catered
              <br />
              to style icons, food connoisseurs, and
              <br />
              entrepreneurial visionaries. Welcome
              <br />
              to LA’s edge.
            </MedText>
          </Row>
        </Fade>
      </SlideMobile>
      <SlideMobile paddingBottom="5em">
        <Fade>
          <AnimatedSingleSquare imgArray={communityRotatingImages} active />
        </Fade>
      </SlideMobile>
    </React.Fragment>
  );
};

export default SectionOneMobile;
